import { drawImage } from '../../drawingUtils';
import BoundingBox from '../BoundingBox';
import ImageElement from './ImageElement';

export default class StaticImageElement extends ImageElement {
  constructor({
    x,
    y,
    url,
    maxWidth,
    minRatio,
    maxRatio,
    imageRegistry,
    onRequestDraw,
  }) {
    super({
      x: x,
      y: y,
      url: url,
      maxWidth: maxWidth,
      minRatio: minRatio,
      maxRatio: maxRatio,
      imageRegistry: imageRegistry,
      onRequestDraw: onRequestDraw,
    });
  }

  override draw(ctx, transform) {
    const url = this.getAttribute('url');
    const image = this.imageRegistry.getImage(url);
    const [xImage, yImage] = transform.apply([this.get('x'), this.get('y')]);
    if (image) {
      drawImage(ctx, transform, image, this, true);
    } else {
      this.imageRegistry.downloadImage(url);
      ctx.fillStyle = 'rgba(141,141,141,0.76)';
      ctx.fillRect(xImage, yImage, this.get('width'), this.get('height'));
    }
  }

  override getBoundingBox(transform): BoundingBox {
    const [x, y] = transform.apply([this.get('x'), this.get('y')]);
    const width = this.get('width');
    const height = this.get('height');

    return new BoundingBox(x, x + width, y, y + height);
  }
}
